<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Hygiene Dashboard</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="County Health Management System by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">HYGIENE CERTIFICATE DASHBOARD</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="#">Hygiene Certificates</a></li>
                    <li class="breadcrumb-item active">Dashboard</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <ToolBarHygiene/>

          <!-- Main Stats Cards -->
          <div class="row">
            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="avatar-sm">
                        <span class="avatar-title rounded-circle bg-info">
                          <i class="mdi mdi-briefcase-edit text-white font-size-20"></i>
                        </span>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h4 class="mb-0">{{ numberFormat(certQuickStats.licenceCountSummary.potentialBusinesses) }}</h4>
                      </div>
                    </div>
                    <p class="text-muted mb-0 small">Potential Businesses</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="avatar-sm">
                        <span class="avatar-title rounded-circle bg-primary">
                          <i class="mdi mdi-briefcase-check text-white font-size-20"></i>
                        </span>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h4 class="mb-0">{{ numberFormat(certQuickStats.licenceCountSummary.invoicedBusinesses) }}</h4>
                      </div>
                    </div>
                    <p class="text-muted mb-0 small">Invoiced Businesses</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="avatar-sm">
                        <span class="avatar-title rounded-circle bg-danger">
                          <i class="mdi mdi-progress-clock text-white font-size-20"></i>
                        </span>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h4 class="mb-0">{{ numberFormat(certQuickStats.licenceCountSummary.unPaidInvoices) }}</h4>
                      </div>
                    </div>
                    <p class="text-muted mb-0 small">Unpaid Invoices</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="avatar-sm">
                        <span class="avatar-title rounded-circle bg-success">
                          <i class="mdi mdi-cash-multiple text-white font-size-20"></i>
                        </span>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h4 class="mb-0">{{ numberFormat(certQuickStats.licenceCountSummary.paidInvoices) }}</h4>
                      </div>
                    </div>
                    <p class="text-muted mb-0 small">Paid Invoices</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="avatar-sm">
                        <span class="avatar-title rounded-circle bg-warning">
                          <i class="mdi mdi-clock-alert text-white font-size-20"></i>
                        </span>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h4 class="mb-0">{{ numberFormat(certQuickStats.licenceCountSummary.awaitingApproval) }}</h4>
                      </div>
                    </div>
                    <p class="text-muted mb-0 small">Awaiting Approval</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="avatar-sm">
                        <span class="avatar-title rounded-circle bg-success">
                          <i class="mdi mdi-certificate text-white font-size-20"></i>
                        </span>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h4 class="mb-0">{{ numberFormat(certQuickStats.licenceCountSummary.activeCertificates) }}</h4>
                      </div>
                    </div>
                    <p class="text-muted mb-0 small">Active Certificates</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Revenue Cards -->
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2">Pending Invoices Value</p>
                      <h4 class="mb-0">KES {{ numberFormat(certQuickStats.licenceAmountSummary.pendingInvoicesSum) }}</h4>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title bg-danger-subtle rounded-circle">
                        <i class="mdi mdi-account-cash text-danger font-size-20"></i>
                      </div>
                    </div>
                  </div>
                  <div class="border-top pt-3">
                    <p class="text-muted mb-0 small">
                      <i class="mdi mdi-information-outline me-1"></i>Total outstanding
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2">Today's Collections</p>
                      <h4 class="mb-0">KES {{ numberFormat(certQuickStats.licenceAmountSummary.todaysCollectionsSum) }}</h4>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title bg-primary-subtle rounded-circle">
                        <i class="mdi mdi-calendar-today text-primary font-size-20"></i>
                      </div>
                    </div>
                  </div>
                  <div class="border-top pt-3">
                    <p class="text-muted mb-0 small">
                      <i class="mdi mdi-clock-outline me-1"></i>Today
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2">This Month's Collections</p>
                      <h4 class="mb-0">KES {{ numberFormat(certQuickStats.licenceAmountSummary.thisMonthsCollectionsSum) }}</h4>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title bg-success-subtle rounded-circle">
                        <i class="mdi mdi-calendar-month text-success font-size-20"></i>
                      </div>
                    </div>
                  </div>
                  <div class="border-top pt-3">
                    <p class="text-muted mb-0 small">
                      <i class="mdi mdi-trending-up me-1"></i>Current month
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2">This FY Collections</p>
                      <h4 class="mb-0">KES {{ numberFormat(certQuickStats.licenceAmountSummary.financialYearCollectionsSum) }}</h4>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title bg-info-subtle rounded-circle">
                        <i class="mdi mdi-calendar-check text-info font-size-20"></i>
                      </div>
                    </div>
                  </div>
                  <div class="border-top pt-3">
                    <p class="text-muted mb-0 small">
                      <i class="mdi mdi-chart-line me-1"></i>Financial year
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Statistics and Chart -->
          <div class="row">
            <div class="col-xl-6">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex justify-content-between align-items-center">
                    <h4 class="card-title mb-0">
                      <i class="mdi mdi-chart-bar me-2"></i>Important Statistics
                    </h4>
                    <span class="badge bg-primary">{{ certQuickStats.statistics.length }} Sub Counties</span>
                  </div>
                </div>

                <div class="card-body" style="max-height: 500px; overflow-y: auto;">
                  <div class="table-responsive">
                    <table class="table table-hover table-nowrap align-middle mb-0">
                      <thead class="table-light">
                      <tr>
                        <th>Sub County</th>
                        <th class="text-center">Invoiced vs Potential</th>
                        <th class="text-center">Pending</th>
                        <th class="text-center">Paid</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in certQuickStats.statistics" :key="index" class="hover-row">
                        <td class="fw-semibold">{{ item.subCountyName }}</td>
                        <td class="text-center">
                          <span class="badge bg-info-subtle text-info">N/A</span>
                        </td>
                        <td class="text-center">
                          <div>
                            <span class="badge bg-danger">{{ numberFormat(item.pendingCount) }}</span>
                            <div class="text-muted small mt-1">KES {{ numberFormat(item.pendingTotal) }}</div>
                          </div>
                        </td>
                        <td class="text-center">
                          <div>
                            <span class="badge bg-success">{{ numberFormat(item.paidCount) }}</span>
                            <div class="text-muted small mt-1">KES {{ numberFormat(item.paidTotalSum) }}</div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th><strong>Total</strong></th>
                        <th class="text-center">-</th>
                        <td class="text-center">
                          <div>
                            <span class="fw-bold">{{ numberFormat(totalPendingCount) }}</span>
                            <div class="small mt-1">KES {{ numberFormat(totalPendingTotal) }}</div>
                          </div>
                        </td>
                        <td class="text-center">
                          <div>
                            <span class="fw-bold">{{ numberFormat(totalPaidCount) }}</span>
                            <div class="small mt-1">KES {{ numberFormat(totalPaidTotalSum) }}</div>
                          </div>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-6">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <h4 class="card-title mb-0">
                    <i class="mdi mdi-chart-line me-2"></i>Revenue Performance
                  </h4>
                </div>
                <div class="card-body">
                  <div id="revenuePerfomanceFire" style="min-height: 400px;"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">Developed by County</div>
            </div>
          </div>
        </div>
      </footer>

    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import Highcharts from 'highcharts';
import 'highcharts/modules/drilldown';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/accessibility';

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
    decimalPoint: '.'
  }
});

import NavigationBar from "@/components/Navigation.vue";
import ToolBarHygiene from "@/components/hygiene/ToolBarHygiene.vue";
import {execute, health, biller} from "@/api";

export default {
  name: "HygieneDashboard",
  components: {ToolBarHygiene, NavigationBar},
  data() {
    return {
      paymentMode: '',
      certQuickStats: {
        licenceCountSummary: {
          potentialBusinesses: 0,
          invoicedBusinesses: 0,
          paidInvoices: 0,
          unPaidInvoices: 0,
          awaitingApproval: 0,
          activeCertificates: 0,
        },
        licenceAmountSummary: {
          pendingInvoicesSum: 0,
          todaysCollectionsSum: 0,
          thisMonthsCollectionsSum: 0,
          financialYearCollectionsSum: 0,
        },
        revenuePerformance: [],
        statistics: []
      },
      totalPendingCount: 0,
      totalPendingTotal: 0,
      totalPaidCount: 0,
      totalPaidTotalSum: 0,
    }
  },
  mounted() {
    this.getDashboard();
    this.menuAccess();
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Hygiene Dashboard");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error('Menu access error:', e.message));
    },
    numberFormat(num) {
      if (!num) return '0';
      return new Intl.NumberFormat("en-GB").format(num);
    },
    revenuePerformance() {
      function abbreviateMonth(month) {
        return month.substring(0, 3);
      }

      var data = this.certQuickStats.revenuePerformance;

      Highcharts.setOptions({
        chart: {
          style: {
            fontFamily: 'Montserrat, sans-serif'
          }
        }
      });

      Highcharts.chart('revenuePerfomanceFire', {
        chart: {
          type: 'column'
        },
        title: {
          text: null
        },
        xAxis: {
          categories: data.map(item => abbreviateMonth(item[0]))
        },
        yAxis: {
          title: {
            text: 'Revenue (KES)'
          }
        },
        legend: {
          enabled: true
        },
        tooltip: {
          shared: true,
          pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>KES {point.y:,.0f}</b><br/>'
        },
        plotOptions: {
          column: {
            pointWidth: 20,
            borderWidth: 0
          }
        },
        series: [{
          name: 'Last Year Collections',
          data: data.map(item => item[1]),
          color: '#556ee6'
        }, {
          name: 'This Year Collections',
          data: data.map(item => item[2]),
          color: '#34c38f'
        }]
      });
    },
    getDashboard() {
      const data = new FormData();
      data.append("function", "getDashboard");
      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.certQuickStats = res.data.data.certQuickStats;

              this.totalPendingCount = this.certQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.pendingCount);
                return !isNaN(amountToday) ? acc + amountToday : acc;
              }, 0);

              this.totalPendingTotal = this.certQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.pendingTotal);
                return !isNaN(amountToday) ? acc + amountToday : acc;
              }, 0);

              this.totalPaidCount = this.certQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.paidCount);
                return !isNaN(amountToday) ? acc + amountToday : acc;
              }, 0);

              this.totalPaidTotalSum = this.certQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.paidTotalSum);
                return !isNaN(amountToday) ? acc + amountToday : acc;
              }, 0);

              this.revenuePerformance();
            }
          })
          .catch((e) => console.error('Error:', e.message));
    }
  }
}
</script>

<style scoped>
.mini-stats-wid .card-body {
  padding: 1.25rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hover-row {
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-row:hover {
  background-color: #f8f9fa;
  transform: translateX(2px);
}

.bg-primary-subtle {
  background-color: rgba(85, 110, 230, 0.18);
}

.bg-success-subtle {
  background-color: rgba(52, 195, 143, 0.18);
}

.bg-danger-subtle {
  background-color: rgba(244, 106, 106, 0.18);
}

.bg-info-subtle {
  background-color: rgba(80, 165, 241, 0.18);
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: none;
  margin-bottom: 1.5rem;
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
}

.table > :not(caption) > * > * {
  padding: 0.75rem;
}

@media (max-width: 768px) {
  .avatar-sm {
    height: 2.5rem;
    width: 2.5rem;
  }

  h4 {
    font-size: 1.25rem;
  }

  .card-body {
    padding: 1rem;
  }
}
</style>